// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agenda-table-item {
  background-color: transparent !important;
  border-radius: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  border-bottom: 1px solid var(--default-border-color);
}
.agenda-table-item__header {
  display: flex;
  flex-direction: column;
  cursor: default !important;
}
@media (min-width: 768px) {
  .agenda-table-item__header {
    flex-direction: row;
  }
  .agenda-table-item__header > *:nth-child(1) {
    flex-basis: 55%;
    padding-right: 30px;
  }
  .agenda-table-item__header > *:nth-child(2) {
    flex-basis: 20%;
    padding-right: 30px;
  }
  .agenda-table-item__header > *:nth-child(3) {
    flex-basis: 25%;
  }
}
@media (min-width: 1200px) {
  .agenda-table-item__header > *:nth-child(1) {
    padding-right: 15%;
  }
}
.agenda-table-item__header.no-hover {
  cursor: default !important;
}
.agenda-table-item__title {
  margin: 0 !important;
  color: var(--agenda-title-color) !important;
}
@media (min-width: 768px) {
  .agenda-table-item__title {
    font-size: 19px !important;
  }
}
.agenda-table-item__title-lg {
  color: var(--agenda-title-color) !important;
  margin-top: 0 !important;
  font-size: 30px !important;
}
.agenda-table-item__description {
  margin-top: 5px;
  color: var(--agenda-description-color) !important;
}
.agenda-table-item__time {
  color: var(--agenda-time-color) !important;
}
.agenda-table-item__timing {
  color: var(--agenda-timing-color) !important;
  font-weight: var(--agenda-timing-font-weight) !important;
}
.agenda-table-item__time-info {
  margin-top: 10px;
}
@media (min-width: 768px) {
  .agenda-table-item__time-info {
    margin-top: 0;
    font-size: 16px;
  }
}
.agenda-table-item__details-button-container {
  display: none;
}
@media (min-width: 768px) {
  .agenda-table-item__details-button-container {
    display: inline-block;
    align-self: center;
  }
}
.agenda-table-item .ant-card-meta-title {
  color: var(--agenda-speaker-text-color) !important;
  font-weight: 600;
}
@media (min-width: 768px) {
  .agenda-table-item .ant-collapse-expand-icon {
    display: none !important;
  }
}
.agenda-table-item .ant-collapse-expand-icon span {
  font-size: 18px !important;
}
.agenda-table-item .ant-collapse-header {
  padding: 0 !important;
  padding-bottom: 30px !important;
  cursor: default !important;
}
.agenda-table-item .ant-collapse-item {
  border: 0 !important;
  cursor: default !important;
}
.agenda-table-item .ant-collapse-content-box {
  padding: 30px !important;
}
.agenda-table-item__agenda-with-children .ant-collapse-header-text {
  width: 100%;
}
.agenda-table-item__agenda-with-children.hasAgendaConfig .ant-collapse-item {
  border-radius: 0 0 8px 8px !important;
}
.agenda-table-item__agenda-with-children.hasAgendaConfig .ant-collapse-content {
  background-color: unset !important;
}
.agenda-table-item__agenda-with-children__collapse-icon {
  color: var(--agenda-title-color) !important;
}
.agenda-table-item__speaker {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}
.agenda-table-item__speaker .ant-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid var(--speaker-picture-border-color);
}
.agenda-table-item__speaker .ant-card-meta-title {
  color: var(--agenda-speaker-text-color) !important;
  font-weight: 600;
}
.agenda-table-item__speaker_see-more {
  font-size: 0.7rem;
  opacity: 0.6;
  margin: 0 !important;
}
.agenda-table-item__speaker.no-hover {
  cursor: default !important;
}
.agenda-table-item__speakers-list {
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.agenda-table-item__speakers-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
@media (max-width: 767px) {
  .agenda-table-item__speakers-container {
    padding-top: 15px;
  }
}
.agenda-table-item__avatar.is-hidden {
  visibility: hidden;
}
.agenda-table-item__nested-item {
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  padding-bottom: 30px;
}
.agenda-table-item__nested-item:first-of-type {
  padding-top: 10px;
}
.agenda-table-item__nested-item:not(:last-of-type) {
  border-bottom: 1px solid var(--default-border-color);
}
.agenda-table-item__nested-item:last-of-type {
  padding-bottom: 10px;
}
@media (min-width: 768px) {
  .agenda-table-item__nested-item {
    flex-direction: row;
  }
  .agenda-table-item__nested-item > *:nth-child(1) {
    flex-basis: 55%;
    padding-right: 30px;
  }
  .agenda-table-item__nested-item > *:nth-child(2) {
    flex-basis: calc(20% + 9px);
    padding-right: 30px;
  }
}
@media (min-width: 1200px) {
  .agenda-table-item__nested-item > *:nth-child(1) {
    padding-right: 15%;
  }
}
@media (min-width: 1200px) {
  .agenda-table-item__nested-texts {
    padding-left: 20px;
  }
}
.agenda-table-item__nested-title {
  margin: 0 !important;
  color: var(--agenda-title-color) !important;
}
.agenda-table-item__nested-description {
  margin-top: 5px;
  color: var(--agenda-description-color) !important;
}
.agenda-table-item__speakers-list-label {
  color: var(--agenda-description-color) !important;
}
.agenda-table-item__nested-time-info {
  padding-top: 10px;
  font-size: 16px;
}
@media (min-width: 768px) {
  .agenda-table-item__nested-time-info {
    padding-top: 0;
  }
}
.agenda-table-item__nested-time {
  color: var(--agenda-time-color) !important;
}
.agenda-table-item__nested-timing {
  color: var(--agenda-timing-color) !important;
  font-weight: var(--agenda-timing-font-weight) !important;
}
.agenda-table-item__nested-speakers-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}
@media (max-width: 767px) {
  .agenda-table-item__nested-speakers-container {
    padding-top: 15px;
  }
}
@media (max-width: 767px) {
  .agenda-table-item__nested-texts, .agenda-table-item__nested-time-info {
    padding-left: 20px;
    border-left: 1px solid var(--default-border-color);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/AgendaTableItem/AgendaTableItem.scss"],"names":[],"mappings":"AAEA;EACI,wCAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,oDAAA;AADJ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,0BAAA;AADR;AAGQ;EALJ;IAMQ,mBAAA;EAAV;EAEU;IACI,eAAA;IACA,mBAAA;EAAd;EAGU;IACI,eAAA;IACA,mBAAA;EADd;EAIU;IACI,eAAA;EAFd;AACF;AAKQ;EACI;IACI,kBAAA;EAHd;AACF;AAMQ;EACI,0BAAA;AAJZ;AAQI;EACI,oBAAA;EACA,2CAAA;AANR;AAQQ;EAJJ;IAKQ,0BAAA;EALV;AACF;AAOQ;EACI,2CAAA;EACA,wBAAA;EACA,0BAAA;AALZ;AASI;EACI,eAAA;EACA,iDAAA;AAPR;AAUI;EACI,0CAAA;AARR;AAWI;EACI,4CAAA;EACA,wDAAA;AATR;AAYI;EACI,gBAAA;AAVR;AAYQ;EAHJ;IAIQ,aAAA;IACA,eAAA;EATV;AACF;AAYI;EACI,aAAA;AAVR;AAYQ;EAHJ;IAIQ,qBAAA;IACA,kBAAA;EATV;AACF;AAYI;EACI,kDAAA;EACA,gBAAA;AAVR;AAcQ;EADJ;IAEQ,wBAAA;EAXV;AACF;AAaQ;EACI,0BAAA;AAXZ;AAeI;EACI,qBAAA;EACA,+BAAA;EACA,0BAAA;AAbR;AAgBI;EACI,oBAAA;EACA,0BAAA;AAdR;AAiBI;EACI,wBAAA;AAfR;AAmBQ;EACI,WAAA;AAjBZ;AAoBY;EAEI,qCAAA;AAnBhB;AAsBY;EACI,kCAAA;AApBhB;AAwBQ;EACI,2CAAA;AAtBZ;AA0BI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAxBR;AA0BQ;EACI,aAAA;EACA,cAAA;EACA,qDAAA;AAxBZ;AA2BQ;EACI,kDAAA;EACA,gBAAA;AAzBZ;AA4BQ;EACI,iBAAA;EACA,YAAA;EACA,oBAAA;AA1BZ;AA6BQ;EACI,0BAAA;AA3BZ;AA+BI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;AA7BR;AAgCI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AA9BR;AAgCQ;EANJ;IAOQ,iBAAA;EA7BV;AACF;AAiCQ;EACI,kBAAA;AA/BZ;AAmCI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;AAjCR;AAmCQ;EACI,iBAAA;AAjCZ;AAoCQ;EACI,oDAAA;AAlCZ;AAqCQ;EACI,oBAAA;AAnCZ;AAsCQ;EAlBJ;IAmBQ,mBAAA;EAnCV;EAqCU;IACI,eAAA;IACA,mBAAA;EAnCd;EAsCU;IACI,2BAAA;IACA,mBAAA;EApCd;AACF;AAuCQ;EACI;IACI,kBAAA;EArCd;AACF;AA0CQ;EADJ;IAEQ,kBAAA;EAvCV;AACF;AA2CI;EACI,oBAAA;EACA,2CAAA;AAzCR;AA4CI;EACI,eAAA;EACA,iDAAA;AA1CR;AA6CI;EACI,iDAAA;AA3CR;AA8CI;EACI,iBAAA;EACA,eAAA;AA5CR;AA8CQ;EAJJ;IAKQ,cAAA;EA3CV;AACF;AA8CI;EACI,0CAAA;AA5CR;AA+CI;EACI,4CAAA;EACA,wDAAA;AA7CR;AAgDI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AA9CR;AAgDQ;EAPJ;IAQQ,iBAAA;EA7CV;AACF;AAkDQ;EAFJ;IAGQ,kBAAA;IACA,kDAAA;EA/CV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
